import { Breadcrumbs, Button, Card, CardContent, List, ListItem, ListItemIcon, ListItemText, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React from "react";
import { Helmet } from "react-helmet";
import { Link, useNavigate } from "react-router-dom";
import DoneIcon from '@mui/icons-material/Done';
import { takenTreament, user } from "../common/type";

const TakenTreatment = (props: {user: user | null; takenTreatment: takenTreament | null}) => {
    const currencyFormatter = new Intl.NumberFormat();
    const navigate = useNavigate()
    const { user, takenTreatment } = props

    const checkRemainingPayment = () => {
        if (takenTreatment)
            if (takenTreatment.price - takenTreatment.total <= 0.0)
                return true
            else
                return false
        else
            return false
    }

    return <>
        <Helmet><title>Taken Treatment</title></Helmet>
        <div className="dark:text-black w-full">
            <div className="lg:m-12 m-4">
                <div className="bg-amber50 shadow-md rounded w-full lg:px-20 px-3 py-10 pt-5">
                    <div className="">
                        <Breadcrumbs className="pb-5 color: rgb(0 0 0)" aria-label="breadcrumb">
                            <Link
                                color="black"
                                to="/patient"
                                className="hover:underline color: rgb(0 0 0)"
                            >
                                <Typography>Patient</Typography>
                            </Link>
                            <Typography className="text-black">Taken Treatment</Typography>
                        </Breadcrumbs>
                        {
                            user?.roles.some((role) => role.name === 'Cashier' || role.name === 'Admin')
                                ?
                                <Button variant="contained" disabled={checkRemainingPayment()} onClick={() => navigate('/payment')}>Add Payment</Button>
                                :
                                <></>
                        }
                        <div className="lg:grid lg:grid-cols-3 grid-cols-1 gap-5">
                            <div className="col-span-2">
                                <span className="lg:text-2xl text-xl font-bold" >Remaining Payment: {takenTreatment ?
                                    currencyFormatter.format(takenTreatment.price - takenTreatment.total)
                                    : 0.0} ETB</span>
                                <div className="shadow py-5 pr-5">
                                    <Typography variant="h5">Amount To Pay: {takenTreatment ? currencyFormatter.format(takenTreatment.price) : 0.0}</Typography>
                                    <Typography variant="h5">Paid: {takenTreatment ? currencyFormatter.format(takenTreatment.total) : 0.0}</Typography>
                                </div>
                                <div className="py-5 lg:pr-5">
                                    <Typography variant="h6">Transactions</Typography>
                                    <TableContainer component={Paper}>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Amount</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Type</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Purpose</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Description</TableCell>
                                                    <TableCell sx={{ fontWeight: 'bold' }}>Created Date</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    takenTreatment && takenTreatment?.Transactions?.length > 0
                                                        ?
                                                        takenTreatment?.Transactions?.map((transaction) => (
                                                            <TableRow>
                                                                <TableCell>{currencyFormatter.format(transaction.amount)}</TableCell>
                                                                <TableCell>{transaction.type}</TableCell>
                                                                <TableCell>{transaction.purpose}</TableCell>
                                                                <TableCell>{transaction.description}</TableCell>
                                                                <TableCell>{new Date(transaction.createdAt).toDateString()}</TableCell>
                                                            </TableRow>
                                                        ))
                                                        :
                                                        <TableRow>
                                                            <TableCell colSpan={4} align="center">No Transaction</TableCell>
                                                        </TableRow>
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                            <Card className="py-5">
                                <CardContent>
                                    {/* <Typography variant="h6">Range Info</Typography>
                                    <List>
                                        {
                                            takenTreatment && takenTreatment?.rangeInfo !== ""
                                                ?
                                                takenTreatment.rangeInfo?.split(',')?.map((range) => (
                                                    <ListItem>
                                                        <ListItemIcon><DoneIcon /></ListItemIcon>
                                                        <ListItemText>{range}%</ListItemText>
                                                    </ListItem>
                                                ))
                                                :
                                                <>No Range Info Found</>
                                        }
                                    </List> */}
                                    <Typography variant="h5">5 Possible Appointments</Typography>
                                    <p className="text-sm">
                                        {takenTreatment ?
                                            <>
                                                {takenTreatment.Appointment?.cycle} Days Cycle. {new Date(takenTreatment.Appointment?.start).toDateString()}{" "}
                                                ~ {new Date(takenTreatment.Appointment?.end).toDateString()}
                                            </>
                                            :
                                            <></>
                                        }
                                    </p>
                                    <List>
                                        {
                                            takenTreatment && takenTreatment?.PossibleAppointments?.length > 0
                                                ?
                                                takenTreatment.PossibleAppointments.map((appointment) => (
                                                    <ListItem>
                                                        <ListItemIcon><DoneIcon /></ListItemIcon>
                                                        <ListItemText>{new Date(appointment.appointmentDate).toDateString()}</ListItemText>
                                                    </ListItem>
                                                ))
                                                :
                                                <>No Possible Appointment Found</>
                                        }
                                    </List>
                                </CardContent>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
};

export default TakenTreatment;
